<div class="risk-card" *ngIf="selectedRisk as risk">
  <div class="header-row">
    <div class="detected-label">
      <span *ngIf="isMulti">{{ "risks.detected_risks" | translate }} ({{ image.risks.length }})</span>
      <span *ngIf="!isMulti">{{ "risks.detected_risk" | translate }}</span>
    </div>

    <mat-chip class="unit-chip" *ngIf="risk.unitName">
      <span>{{ risk.unitName }}</span>
    </mat-chip>
  </div>

  <div class="single-title" *ngIf="!isMulti">
    <h2>
      <a class="risk-link" [routerLink]="['/project/risk/'+ risk.id]">
        {{ risk.payload.displayTitle || risk.payload.title }}
      </a>
    </h2>
  </div>

  <mat-divider *ngIf="!isMulti" [style.backgroundColor]="risk.payload.color"></mat-divider>

  <div class="tab-bar" *ngIf="isMulti">
    <button type="button" class="tab-arrow" *ngIf="canScrollLeft" (click)="scrollTabs(-1)"
      aria-label="scroll left">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <div class="tab-scroll" #tabScroll (scroll)="updateArrows()">
      <button type="button" class="risk-tab" #tabEl *ngFor="let entry of image.risks"
        [class.selected]="entry.number === selectedNumber" (click)="onSelect(entry)"
        [title]="riskName(entry)">
        <span class="tab-badge">{{ entry.number }}</span>
        <span class="tab-name">{{ riskName(entry) }}</span>
      </button>
    </div>

    <button type="button" class="tab-arrow" *ngIf="canScrollRight" (click)="scrollTabs(1)"
      aria-label="scroll right">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <div class="list-rows">
    <div class="group">
      <div class="label">{{ "risks.date" | translate }}</div>
      <div class="value">{{ risk.payload.startDate ?? '' | timeFormat : "dd/MM/yyyy" }}</div>
    </div>

    <div class="group">
      <div class="label">{{ "risks.hour" | translate }}</div>
      <div class="value">{{ risk.payload.startDate ?? '' | timeFormat : "HH:mm:ss" }}</div>
    </div>

    <div class="group">
      <div class="label">{{ "risks.sequence" | translate }}</div>
      <div class="value">{{ risk.payload.sequence }}</div>
    </div>

    <div class="group">
      <div class="label">{{ "risks.zone" | translate }}</div>
      <div class="value">{{ risk.payload.zone }}</div>
    </div>

    <div class="group full">
      <div class="label">
        <span>{{ "risks.description" | translate }}</span>
      </div>
      <div class="value">{{ risk.payload.description }}</div>
    </div>
  </div>

  <div class="group full" *ngIf="actionsByRisk[risk.id]?.length">
    <div class="label">{{ "actions.title" | translate }}</div>
    <div class="action-chips">
      <a *ngFor="let a of actionsByRisk[risk.id]" class="action-chip" (click)="openAction.emit(a.id)">
        <lib-chip color="primary" icon="checklist" [text]="a.title"></lib-chip>
      </a>
    </div>
  </div>

  <div class="group full">
    <div class="label">
      {{ "risks.comment" | translate }}
      <span class="author">{{ risk.payload.commentedBy }}</span>
    </div>

    <mat-form-field class="input-full-width" appearance="outline">
      <textarea matInput [(ngModel)]="risk.payload.comment" (blur)="commentEdit.emit()" rows="3"></textarea>
    </mat-form-field>
  </div>

  <div class="group-button">
    <lib-button [icon]="'image_file'" [text]="'risks.ask_image' | translate" [color]="'primary'"
      (click)="showImage.emit()">
    </lib-button>

    <lib-button [icon]="'error'" [color]="'warning'" [text]="'risks.report_title' | translate"
      (click)="report.emit()">
    </lib-button>

    <lib-button [icon]="'checklist'" [color]="'secondary'" [text]="'actions.link_from_risk' | translate"
      (click)="linkAction.emit()">
    </lib-button>
  </div>
</div>
